"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorCardStatus = exports.sortAlertsBySeverityFunction = exports.AlertStatus = exports.SensorAlertSeverity = exports.BranchCircuitAlertTypes = exports.SensorAlertType = void 0;
var SensorAlertType;
(function (SensorAlertType) {
    SensorAlertType["Leak"] = "LEAK";
    SensorAlertType["LowHumidity"] = "LOW_HUMIDITY";
    SensorAlertType["HighHumidity"] = "HIGH_HUMIDITY";
    SensorAlertType["LowMCTCurrent"] = "LOW_MCT_CURRENT";
    SensorAlertType["HighMCTCurrent"] = "HIGH_MCT_CURRENT";
    SensorAlertType["LowBCTCurrent"] = "LOW_BCT_CURRENT";
    SensorAlertType["HighBCTCurrent"] = "HIGH_BCT_CURRENT";
    SensorAlertType["LowVoltage"] = "LOW_VOLTAGE";
    SensorAlertType["HighVoltage"] = "HIGH_VOLTAGE";
    SensorAlertType["LowCurrent"] = "LOW_CURRENT";
    SensorAlertType["HighCurrent"] = "HIGH_CURRENT";
    SensorAlertType["LowPressure"] = "LOW_PRESSURE";
    SensorAlertType["HighPressure"] = "HIGH_PRESSURE";
    SensorAlertType["HVACfilter"] = "HVAC_FILTER";
    SensorAlertType["LowTC"] = "LOW_TC";
    SensorAlertType["HighTC"] = "HIGH_TC";
    SensorAlertType["HighIAQ"] = "HIGH_IAQ";
    SensorAlertType["HighPM"] = "HIGH_PM";
    SensorAlertType["LowEC"] = "LOW_EC";
    SensorAlertType["HighEC"] = "HIGH_EC";
    SensorAlertType["LowBattery"] = "LOW_BATTERY";
    SensorAlertType["HvacFilter"] = "HVAC_FILTER";
    SensorAlertType["Unknown"] = "UNKNOWN";
})(SensorAlertType = exports.SensorAlertType || (exports.SensorAlertType = {}));
exports.BranchCircuitAlertTypes = [
    SensorAlertType.LowMCTCurrent,
    SensorAlertType.HighMCTCurrent,
];
var SensorAlertSeverity;
(function (SensorAlertSeverity) {
    SensorAlertSeverity["Critical"] = "critical";
    SensorAlertSeverity["High"] = "high";
    SensorAlertSeverity["Medium"] = "medium";
    SensorAlertSeverity["Low"] = "low";
    SensorAlertSeverity["Info"] = "info";
})(SensorAlertSeverity = exports.SensorAlertSeverity || (exports.SensorAlertSeverity = {}));
var AlertStatus;
(function (AlertStatus) {
    AlertStatus["NEW"] = "new";
    AlertStatus["ONGOING"] = "ongoing";
    AlertStatus["PENDING"] = "pending";
    AlertStatus["ACTIVE"] = "active";
    AlertStatus["ACKNOWLEDGED"] = "acknowledged";
    AlertStatus["RESOLVED"] = "resolved";
    AlertStatus["EXPIRED"] = "expired";
})(AlertStatus = exports.AlertStatus || (exports.AlertStatus = {}));
/**
 * Sorts sensor alerts by severity, with Critical severity first.
 * @param alerts Array of sensor alerts to sort
 * @returns Sorted array of sensor alerts
 */
const sortAlertsBySeverityFunction = (alertA, alertB) => {
    const severityOrder = {
        [SensorAlertSeverity.Critical]: 0,
        [SensorAlertSeverity.High]: 1,
        [SensorAlertSeverity.Medium]: 2,
        [SensorAlertSeverity.Low]: 3,
        [SensorAlertSeverity.Info]: 4,
    };
    return (severityOrder[alertA.severity] -
        severityOrder[alertB.severity]);
};
exports.sortAlertsBySeverityFunction = sortAlertsBySeverityFunction;
var SensorCardStatus;
(function (SensorCardStatus) {
    SensorCardStatus["Good"] = "good";
    SensorCardStatus["Poor"] = "poor";
    SensorCardStatus["Error"] = "error";
})(SensorCardStatus = exports.SensorCardStatus || (exports.SensorCardStatus = {}));
